import { makeStyles, tokens } from "@fluentui/react-components";

export const useWorkspaceMenuSelectorStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    alignItems: "center",
    columnGap: "3px",
  },
  link: {
    fontWeight: tokens.fontWeightSemibold,
  },
  menuPopover: {
    maxHeight: "200px",
  },
});
